import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { applyKeyframe, mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css, keyframes } from 'styled-components';

const { fonts, spacing } = theme;

export const wrapper = css`
  position: relative;
`;

export const expandedResultsMessage = css`
  grid-column: 1 / -1;
  margin: 0 ${spacing.xxl}px;
  text-align: center;
  font-family: ${fonts.PRIMARY_REGULAR.family};
  font-weight: ${fonts.PRIMARY_REGULAR.weight};
  ${theme.responsiveText.BODY.MD};
  color: var(--neutral-black-base);
`;

export const noMatchingProducts = css`
  margin: 32px 0 40px;
  text-align: center;
  color: var(${themeVariables.colors.content.default});
`;

export const noMatchingProductsHeading = css`
  margin: 0 0 8px;
  font-family: var(${themeVariables.typography.heading.fontFamily});
  font-weight: var(${themeVariables.typography.heading.fontWeight});
  font-size: var(${themeVariables.typography.heading.sizes.xs.fontSize});
  line-height: var(${themeVariables.typography.heading.sizes.xs.lineHeight});
`;

export const noMatchingProductsHint = css`
  margin: 0;
  font-family: var(${themeVariables.typography.body.fontFamily});
  font-size: var(${themeVariables.typography.body.sizes.sm.fontSize});
  line-height: var(${themeVariables.typography.body.sizes.sm.lineHeight});
`;

export const loadPageWrapper = css`
  margin-bottom: ${spacing.xxxl}px;
  text-align: center;
`;

export const progressWrapper = css`
  margin: 0 0 ${pxToRem(8)};
  text-align: center;

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      margin-bottom: ${pxToRem(40)};
    `,
  )};
`;

export const progressMessage = css`
  ${theme.responsiveText.BODY.XS}
  margin: 0;
  color: var(${themeVariables.colors.content.default});
  font-family: var(${themeVariables.typography.body.fontFamily});
  font-size: var(${themeVariables.typography.body.sizes.sm.fontSize});
`;

const fadeInAnimation = keyframes`
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`;

export const fadeIn = css`
  animation: ${applyKeyframe(fadeInAnimation)} 400ms linear;
`;
